import {useI18n} from "./i18nContext";
import {Localize, FormatCurrency} from "./types";

export type UseLocalize = () => {
  localize: Localize;
  formatCurrency: FormatCurrency;
};

export const useLocalize: UseLocalize = () => {
  const {localize, formatCurrency} = useI18n();
  return {localize, formatCurrency};
};
